import { h } from 'preact';
import classNames from 'classnames';

const PillOption = ({ value }) => {
  const pillOptionClasses = [
    'peer-checked:bg-gray-600',
    'peer-disabled:cursor-not-allowed',
    'peer-disabled:border-none',
    'peer-disabled:text-gray-600',
    'peer-disabled:bg-transparent',
    'peer-disabled:ring-gray-800',
    'peer-data-[unavailable]:text-gray-600',
    'peer-data-[unavailable]:bg-transparent',
    'peer-data-[unavailable]:ring-gray-800',
    'peer-checked:peer-data-[unavailable]:border-gray-800',
    'peer-data-[unavailable]:after:content-[""]',
    'peer-data-[unavailable]:after:slash',
    'peer-data-[unavailable]:after:absolute',
    'peer-data-[unavailable]:after:w-full',
    'peer-data-[unavailable]:after:inset-0',
    'peer-data-[unavailable]:items-center',
    'body-2',
    'flex',
    'justify-center',
    'rounded-sm',
    'border',
    'bg-inverse',
    'border-transparent',
    'px-10',
    'min-h-[40px]',
    'items-center',
    'text-center',
    'ring-1',
    'ring-gray-900',
    'flex-wrap',
    'relative',
    'py-2',
  ];

  return <span className={classNames(pillOptionClasses)}>{value}</span>;
};

export default PillOption;
